import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2c30ad90&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=2c30ad90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30ad90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c30ad90')) {
      api.createRecord('2c30ad90', component.options)
    } else {
      api.reload('2c30ad90', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=2c30ad90&scoped=true&", function () {
      api.rerender('2c30ad90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hotel/detail.vue"
export default component.exports